// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const RecordSchema = z.object({
    customerId: z.string().min(1, 'Required'),
    subscriptionId: z.string().min(1, 'Required'),
});
